import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=5e7d48cd&scoped=true"
import script from "./Properties.vue?vue&type=script&lang=js"
export * from "./Properties.vue?vue&type=script&lang=js"
import style0 from "./Properties.vue?vue&type=style&index=0&id=5e7d48cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d48cd",
  null
  
)

export default component.exports